/* eslint-disable no-useless-catch */
import axios from "axios";

export default {
  state: {},
  actions: {
    async getCategoriasMenu({ rootState }) {
      try {
        const response = await axios.get(rootState.api.url + "categorias-menu");
        return response.data;
      } catch (e) {
        throw e;
      }
    },
    async getCategoriasProductos({ rootState }, id) {
      try {
        const response = await axios.get(
          rootState.api.url + "categorias-productos?id=" + id
        );
        return response.data;
      } catch (e) {
        throw e;
      }
    },
    async saveOrderList({ rootState }, payload) {
      try {
        const response = await axios.post(
          rootState.api.url + "categorias-productos-order",
          payload
        );
        if (!response.data.status) {
          throw response.data.msg;
        }
        return response.data;
      } catch (e) {
        throw e;
      }
    }
  }
};
